import { render } from "./BatterTrainView.vue?vue&type=template&id=57f71074&scoped=true"
import script from "./BatterTrainView.vue?vue&type=script&lang=js"
export * from "./BatterTrainView.vue?vue&type=script&lang=js"

import "./BatterTrainView.vue?vue&type=style&index=0&id=57f71074&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f71074"]])

export default __exports__